export default class RedesignBrowserInterop {

    DownloadFileFromStream = async function (contentStreamReference, fileName, fileType) {
      const arrayBuffer = await contentStreamReference.arrayBuffer()
      const blob = new Blob([arrayBuffer], { type: fileType })
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
}
